import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import noResult from '../../assets/no-result.svg';

const NoResult = (props) => {

    return (
        <main>
        <Container fluid>
            <div>
                <Row className="justify-content-md-center">
                    <Col  sm={12} md={12} lg={12} className="d-none d-lg-block" style={{display: 'flex', flexDirection: 'column', textAlign: 'center'}}>
                        <br></br>
                        <h3>{!props.mensagem ? "Nenhum resultado encontrado!" : props.mensagem}</h3>
                        <br></br>
                        <img src={noResult} alt="No Result" style={{width: '365px'}} />
                    </Col>
                </Row>
            </div>
        </Container>
        </main>
    )

}

export default NoResult;